// src/utils/auth.js
export const isTokenExpired = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        return true; // No token, so it's "expired"
    }

    try {
        const decodedToken = JSON.parse(atob(token.split('.')[1]));
        return decodedToken.exp * 1000 < Date.now(); // Check if expiration is before current time
    } catch (error) {
        // Handle any errors while decoding (e.g., invalid token format)
        console.error("Error decoding token:", error);
        return true; // Treat as expired to be safe
    }
};